import PropTypes from "prop-types";
import React, { Component } from "react";
import "./styles.css";

export default class GoogleButton extends Component {
  static propTypes = {
    clientId: PropTypes.string.isRequired,
    onLogin: PropTypes.func.isRequired
  };

  onSignIn = googleUser => {
    const profile = googleUser.getBasicProfile();
    this.props.onLogin({
      tokenObj: googleUser.getAuthResponse(),
      profileObj: {
        email: profile.getEmail(),
        familyName: profile.getFamilyName(),
        givenName: profile.getGivenName(),
        googleId: profile.getId(),
        imageUrl: profile.getImageUrl(),
        name: profile.getName()
      }
    });
  };

  renderGoogleLoginButton = () => {
    /* global gapi */
    this.setState({ isGoogleReady: true }, this.init);
    gapi.signin2.render("google-signIn", {
      scope: "email profile openid",
      longtitle: true,
      theme: "light",
      height: 40,
      onsuccess: this.onSignIn
    });
  };

  componentDidMount() {
    const body = document.getElementsByTagName("body")[0];
    const head = document.getElementsByTagName("head")[0];

    // create event listener for google api loaded
    window.addEventListener("google-loaded", this.renderGoogleLoginButton);

    // create the google script
    let script = document.createElement("script");
    script.type = "text/javascript";
    script.src =
      "https://apis.google.com/js/platform.js?onload=triggerGoogleLoaded";

    // create the method to be invoked for the google script
    // dispatch a new event as a little hack/workaround
    let scriptTrigger = document.createElement("script");
    scriptTrigger.type = "text/javascript";
    scriptTrigger.text =
      "function triggerGoogleLoaded(){window.dispatchEvent(new Event('google-loaded'))}";

    // create the meta tags to be used
    let meta = document.createElement("meta");
    meta.name = "google-signin-client_id";
    meta.content = this.props.clientId;

    // finally append
    head.append(meta);
    body.append(scriptTrigger);
    body.append(script);
  }

  render() {
    return <div id="google-signIn" className="g-signin2" />;
  }
}



// WEBPACK FOOTER //
// ./src/library/button/GoogleButton/index.js